import {combineReducers} from "redux";

import prismic from "./prismic";
import loading from "./loading";
import cookieCompliance from "./cookie_compliance";
import accessibility from "./accessibility";

const rootReducer = combineReducers({
  prismic,
  loading,
  cookieCompliance,
  accessibility,
});

export default rootReducer;
